"use client";

import { optionListsFor } from "@/features/quote/shared/quote-config";
import { StepHeading } from "@/features/quote/ui/StepHeading";
import { StepNav } from "@/features/quote/ui/StepNav";
import { useStep, useWizard } from "@/features/quote/ui/wizard-context";
import { RadioCards } from "@/shared/ui/form/RadioCards";

export function FrequencyStep() {
  const { autoAdvance, next, back, canAdvance, isBusiness } = useWizard();
  const [{ frequency = "" }, answer] = useStep("frequency");

  return (
    <section>
      <StepHeading
        title="Hvor ofte?"
        body={
          isBusiness
            ? "Vælg den frekvens der passer bedst - det kan altid justeres senere."
            : "Vælg hvor tit du vil have rengøring - du kan altid justere det senere."
        }
      />
      <RadioCards
        options={optionListsFor(isBusiness ? "erhverv" : "privat").frequencies}
        value={frequency}
        onChange={(v) => {
          answer({ frequency: v });
          autoAdvance();
        }}
        gridClassName={isBusiness ? "grid-cols-2 sm:grid-cols-3" : undefined}
      />
      <StepNav onBack={back} onNext={next} nextEnabled={canAdvance} nextLabel="Næste →" />
    </section>
  );
}
